import API from "../../Api";
import { encryptJson} from "../../utils/react-ec-utils";
import {
  SignUpForm,
  SignUpData,
  SignInForm,
  OTPVerificationDetails,
  MobileVerificationDetails,
  ResetPassword,
} from "./AuthModels";
import { getCookie } from "../../../helper/cookieHelper";
import { ACCESS_TOKEN, USER_DETAILS, USER_ID } from "../../constants";
import { createRequest } from "../../utils/hmac-utils";

const getUserDetailsFromCookie = () => getCookie(USER_DETAILS) || {};

// SignUp
export function signUp(userDetails: SignUpData) {
  return API({
    method: "post",
    url: "/api/customers/sendSMS",
    headers: {
      Authorization: "",
    },
    data: userDetails,
  });
}

// SignIn
export function signIn(userDetails: SignInForm) {
  const data = encryptJson(userDetails);
  return API({
    method: "post",
    url: "/api/customers/login/v2",
    data: {"data":data},
  });
}

// Mobile
export function verifyMobile(details: MobileVerificationDetails) {
  const data = encryptJson(details);
  return API({
    method: "post",
    url: "/api/customers/sendSMS",
    params:{data}
  });
}


export function signInGuestApi(details: MobileVerificationDetails) {
  const data = encryptJson(details);
  return API({
    method: "post",
    url: "/guest/user",
    data:details
  });
}

// OTP
export function verifyOTP(details: OTPVerificationDetails) {
  const data = encryptJson(details);
  return API({
    method: "post",
    url: "/api/customers/validateOTP/v2",
    data: {"data":data},
  });
}

// Reset Password
export  async function resetPassword(details: ResetPassword) {
  const userID = getCookie(USER_ID)
  const payload = {customerId:userID, ...details};
  const data = encryptJson(payload);
  const userDetailsFromCookie = getUserDetailsFromCookie();
      const hmacRequest = await createRequest(payload);
  return API({
    method: "post",
    url: `/api/customers/resetPassword?emailId=${userDetailsFromCookie?.email || ""}&mobileNo=${userDetailsFromCookie?.mobilePhone || ""}`,
    data:hmacRequest
  });
}

export function logoutCustomer(accessToken?: string) {
  return API({
    method: "post",
    url: "/api/customers/logout",
    headers: {
      Accept: "application/json",
      ...(accessToken ? { Authorization: `bearer ${accessToken}` } : {}),
    },
  });
}



// Get Country Code

export function getCountryCode() {
  return API({
    method: "get",
    url: "/api/customers/getCountry",
  });
}

export function getOtp(data: string){
  return API({
    method: 'post',
    url: '/api/customers/auth/request-otp',
    data: data,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

// The body is encrypted, so the backend takes the location from a header instead - it
// reports the login to the fraud assessment service before handing back a token. The caller
// passes the id because it lives in the store; the `restaurant` entry in localStorage holds
// the merchant *slug* under `location`, not the location id.
export function verifyOtp(verifyOtpPayload: any, locationId?: string){
  const encryptedData = encryptJson(verifyOtpPayload);
  return API({
    method: 'post',
    url: `/api/customers/auth/verify-otp`,
    data: { data : encryptedData },
    headers: {
      ...(locationId ? { locationId } : {}),
    },
  })
}


export async function verifyProfileEmailOtp(verifyOtpPayload: any) {
  const hmacRequest = await createRequest(verifyOtpPayload);
  const accessToken = getCookie(ACCESS_TOKEN);

  return API({
    method: 'put',
    url: '/api/customers/auth/verify-otp/v2',
    data: hmacRequest,
    headers: {
      'Content-Type': 'application/json',
      'X-source': 'CA',
      ...(accessToken ? { Authorization: 'Bearer ' + accessToken } : {}),
    },
  });
}

export function updateProfile(details: ResetPassword) {
  const data = encryptJson(details);
  return API({
    method: "post",
    url: "/api/customers/user/fetch",
    params:details,
     headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function logPrint(data: string) {
  return API({
    method: 'post',
    url: '/print/log-info',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export function getServerInfo() {
  return API({
    method: 'get',
    url: '/api/customers/info',
  });
}
